module.exports = __webpack_public_path__ + "static/media/08kcsg.bc55feb6.png";